import React from 'react';

import { getConfig } from '@edx/frontend-platform';
import { useIntl } from '@edx/frontend-platform/i18n';
import PropTypes from 'prop-types';

import {
  RenderInstitutionButton,
  SocialAuthProviders,
} from '../../common-components';
import {
  REGISTER_PAGE,
} from '../../data/constants';
import messages from '../messages';

/**
 * This component renders the Single sign-on (SSO) buttons for the providers passed.
 * */
const ThirdPartyAuth = (props) => {
  const { formatMessage } = useIntl();
  const {
    providers, secondaryProviders, currentProvider, handleInstitutionLogin, // thirdPartyAuthApiStatus,
  } = props;
  const isInstitutionAuthActive = !!secondaryProviders.length && !currentProvider;
  const isSocialAuthActive = !!providers.length && !currentProvider;
  const isEnterpriseLoginDisabled = getConfig().DISABLE_ENTERPRISE_LOGIN;

  const sortProviders = (providers) => {
    const desiredOrder  = getConfig().SSO_PROVIDER_NAMES_ORDER || [];
    const orderMap = new Map(desiredOrder.map((name, index) => [name, index]));
    return [...providers].sort(
      (a, b) =>
        (orderMap.get(a.name) ?? Infinity) - (orderMap.get(b.name) ?? Infinity)
    );
  };

  return (
    <>
      <div className="form-w-third-party-auth">
        {(isEnterpriseLoginDisabled && isInstitutionAuthActive) && (
          <RenderInstitutionButton
            onSubmitHandler={handleInstitutionLogin}
            buttonTitle={formatMessage(messages['register.institution.login.button'])}
          />
        )}
        {isSocialAuthActive && (
          <div className="social-auth-providers form-w-third-party-auth flex-center-column w-100">
            <SocialAuthProviders socialAuthProviders={sortProviders(providers)} referrer={REGISTER_PAGE} />
          </div>
        )}
      </div>
      {((isEnterpriseLoginDisabled && isInstitutionAuthActive) || isSocialAuthActive) && (
        <div className="section-title lines">
          <h3>
            <span className="text">
              {formatMessage(messages['registration.other.options.heading'])}
            </span>
          </h3>
        </div>
      )}
    </>
  );
};

ThirdPartyAuth.defaultProps = {
  currentProvider: null,
  providers: [],
  secondaryProviders: [],
  // thirdPartyAuthApiStatus: 'pending',
};

ThirdPartyAuth.propTypes = {
  currentProvider: PropTypes.string,
  handleInstitutionLogin: PropTypes.func.isRequired,
  providers: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      iconClass: PropTypes.string,
      iconImage: PropTypes.string,
      loginUrl: PropTypes.string,
      registerUrl: PropTypes.string,
    }),
  ),
  secondaryProviders: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      iconClass: PropTypes.string,
      iconImage: PropTypes.string,
      loginUrl: PropTypes.string,
      registerUrl: PropTypes.string,
    }),
  ),
  // thirdPartyAuthApiStatus: PropTypes.string,
};

export default ThirdPartyAuth;
